/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCoupon = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M8 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8 0h-5v-2h5zm-8-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8 0h-5V9h5zM8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        <path d="m22 9.88-.666.236A2 2 0 0 0 20 12c0 .867.554 1.607 1.334 1.883l.666.235V20H2v-5.882l.666-.235A1.998 1.998 0 0 0 4 12a2 2 0 0 0-1.334-1.884L2 9.881V4h20zM4 8.542a3.99 3.99 0 0 1 0 6.916V18h16v-2.543a3.988 3.988 0 0 1 0-6.916V6H4z" />
      </g>
    </g>
  </Icon>
);
export { SvgCoupon as Coupon };
